import { render } from "./ImprestRequest.vue?vue&type=template&id=c080920e&scoped=true"
import script from "./ImprestRequest.vue?vue&type=script&lang=js"
export * from "./ImprestRequest.vue?vue&type=script&lang=js"

import "./ImprestRequest.vue?vue&type=style&index=0&id=c080920e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c080920e"]])

export default __exports__